import React from 'react';
import { Combo } from 'fw/forms';

class NotificationRecipientCombo extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this._isMounted = false;
    }

    completed = () => { return this._ctrl.completed(); }
    flag = () => { return this._ctrl.flag(); }

    componentDidMount = () => {
        this._isMounted = true;

        this.loadNotificationRecipients(null);
    }

    loadNotificationRecipients = () => {
        let items = [];

        items.push({ label: "Corporate Member", value: "SPN"});
        items.push({ label: "VOB", value: "CER"});

        this.setState({items});
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <Combo
                {...this.props}
                placeholder={this.props.placeholder ? this.props.placeholder : "Select Recipient"}
                items={this.state.items}
                searchable={true}
                ref={(c) => { this._ctrl = c }} />
        )
    }
}

export default NotificationRecipientCombo;

// Mark this as a form component
NotificationRecipientCombo.defaultProps = {
    formControl: true,
    managed: false
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/notificationRecipientCombo/NotificationRecipientCombo.js